import queryClient from "../../../../config/queryClient";

export const updateSingleLeadCache = (id, leadData) => {
  // console.log("Updating lead cache", id, leadData);

  queryClient.setQueryData(["lead", id], (oldData) => ({
    ...oldData,
    ...leadData,
  }));
};

export const updateLeadsListCache = ({
  id,
  updatedData,
  page,
  limit,
  queryString = "",
  queryParams = "",
  companyId,
}) => {
  console.log(
    "Updating leads list cache",
    id,
    updatedData,
    page,
    limit,
    companyId
  );

  queryClient.setQueryData(
    [
      "enrollment",
      page,
      limit,
      queryString,
      queryParams,
      companyId,
      "-enrolledOn",
    ],
    (oldData) => {
      if (!oldData) return oldData;
      return {
        ...oldData,
        data: {
          ...oldData.data,
          data: oldData.data.data.map((lead) =>
            lead._id === id ? { ...lead, ...updatedData } : lead
          ),
        },
      };
    }
  );
  // queryClient.invalidateQueries(["leads"]);
};
